<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6633_34790)">
<rect opacity="0.01" width="24" height="24" fill="#444646"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.44507 5.55806C9.20099 5.31398 8.80526 5.31398 8.56118 5.55806C8.32772 5.79152 8.31757 6.16374 8.53073 6.40927L8.56118 6.44194L14.0694 11.95L8.56118 17.4581C8.32772 17.6915 8.31757 18.0637 8.53073 18.3093L8.56118 18.3419C8.79465 18.5754 9.16686 18.5856 9.4124 18.3724L9.44507 18.3419L15.3951 12.3919C15.6285 12.1585 15.6387 11.7863 15.4255 11.5407L15.3951 11.5081L9.44507 5.55806Z" fill="#A09EA3"/>
</g>
<defs>
<clipPath id="clip0_6633_34790">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
